import React from 'react';
import PageHeader from '../../../../components/PageHeader';
import Datatable from '../../../../components/DataTable';
import { Box, Button, IconButton, Menu, MenuItem, Stack, TablePagination, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { CancelToken } from 'apisauce';
import { useEffect } from 'react';
import appapi from '../../../../api/apiClient';
import moment from 'moment';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import { allowEUATrading } from '../../../../redux/features/authSlice';

const screeningStatus = {
  pending: '#BA9B1D',
  approved: '#00A63226',
  rejected: '#B11B1B',
  inprogress: '#006DFF',
  pendingColor: '#fff',
  approvedColor: '#00A632',
  rejectedColor: '#fff',
  inprogressColor: '#fff',
};

const StatusDropdown = ({ item, changeStatusKYC }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeStatus = (traderId, screeningStatus) => {
    setAnchorEl(null);
    changeStatusKYC(traderId, screeningStatus)
  }

  return (<div className="flex !justify-center">
    {item?.screeningStatus === 'approved' && <Stack
      justifyContent={'center'}
      alignItems={'center'}
      className="fw-regular fs-12 ff-Roboto h-[28px] w-[80px] px-[10px] rounded-[16px] capitalize"
      sx={{ backgroundColor: screeningStatus[item?.screeningStatus], color: screeningStatus[`${item?.screeningStatus}Color`] }}
    >
      {item?.screeningStatus}
    </Stack>}

    {item?.screeningStatus !== 'approved' && <> <Button
      id="demo-positioned-button"
      aria-controls={open ? 'demo-positioned-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      variant="contained"
      disableElevation
      onClick={handleClick}
      className="fw-regular !p-0 fs-10 ff-Roboto h-[28px] w-[100px]  rounded-[16px] capitalize"
      endIcon={<KeyboardArrowDownIcon />}
      sx={{
        backgroundColor: screeningStatus[item?.screeningStatus], color: screeningStatus[`${item?.screeningStatus}Color`], textTransform: 'capitalize', '&:hover': {
          backgroundColor: screeningStatus[item?.screeningStatus], color: screeningStatus[`${item?.screeningStatus}Color`]
        }
      }}
    >
      {item?.screeningStatus === 'inprogress' ? 'In Progress' : item?.screeningStatus}
    </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      // anchorOrigin={{
      //   vertical: 'top',
      //   horizontal: 'left',
      // }}
      // transformOrigin={{
      //   vertical: 'top',
      //   horizontal: 'left',
      // }}
      >
        {item?.screeningStatus === 'pending' && <MenuItem className='fw-regular fs-12 ff-Roboto w-[100px]' sx={{ color: screeningStatus.inprogress }} onClick={() => changeStatus(item._id, 'inprogress')}>In Progress</MenuItem>}

        {item?.screeningStatus !== 'rejected' && <MenuItem className='fw-regular fs-12 ff-Roboto w-[100px]' sx={{ color: screeningStatus.rejected }} onClick={() => changeStatus(item._id, 'rejected')}>Reject</MenuItem>}

        <MenuItem className='fw-regular fs-12 ff-Roboto w-[100px]' sx={{ color: screeningStatus.approvedColor }} onClick={() => changeStatus(item._id, 'approved')}>Approve</MenuItem>
      </Menu>
    </>}

  </div>)
}

export default function TraderList({ showTraderRequest, companyId, type, allowTrading, blockedStatus}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { userId } = useSelector((state) => state.auth);

  const { companyDetails } = useSelector((state) => state.auth);

 

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
  });

  const [tradersList, setTradersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);



  let source = CancelToken.source();

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
    },
    {
      id: 1,
      header: 'Trader',
      accessor: 'traderName',
      width: '45%',
      capitalize: true,
    },
    {
      id: 2,
      header: 'Date',
      accessor: 'date',
      width: '15%',
    },
    {
      id: 3,
      header: 'Status',
      accessor: 'status',
      width: '20%',
      Cell: (item) => (
        <StatusDropdown item={item} changeStatusKYC={(trderId, screeningStatus) => changeStatus(trderId, screeningStatus)} />
      ),
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetTrader = async () => {
    setIsLoading(true);
    if (source) {
      source.cancel();
    }
    source = CancelToken.source();
    const response = await appapi.get(
      `/company/allRequests/${companyId}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        field: payload.field,
        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          item.date = moment(item.date).format('DD-MM-YYYY');
          return item;
        });
        setTradersList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setTradersList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setTradersList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  const changeStatus = async (traderId, screeningStatus) => {
    dispatch(setLoading(true));
    const response = await appapi.put(
      `/trader/screeningStatus/${companyId}/${traderId}`,
      { screeningStatus, superAdminId: userId },
    );
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        handleGetTrader();
        showmessage(data.message, 'success');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleAddtrader = (e) => {
   
      if (!allowTrading) {
        showTraderRequest();
      } else {
        
        showmessage(`Please add ${allowTrading} before trading.`, 'error');
      }
    } 

  useEffect(() => {
    if (companyId) {
      handleGetTrader();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter]);

  console.log(allowTrading,"innnnnnnnnnnnnn")

  return (
    <Stack
      flex={1}
      style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', padding: '16px', borderColor: '#8993AC26', borderWidth: '1px' }}
    >
      <Stack style={{ width: '100%' }}>
        <PageHeader
          tableType={'2'}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          searchBarWidth={'150px'}
        >
          <Stack
            direction="row"
            alignItems={'center'}
            style={{ width: '100%' }}
          >
            <Stack>
              <Typography
                className="fs-14 ff-Roboto fw-regular"
                color={text}
              >
                KYC Verification Status
              </Typography>
              {/* <Typography
                className="fs-10 ff-Roboto fw-regular"
                color={textLight}
              >
                List of all the trader who wants to trade with you
              </Typography> */}
            </Stack>
            <Stack flexGrow={1} />
            {/* <IconButton
              onClick={() => {
                showTraderRequest();
              }}
              className=""
            >
              <Typography
                color={theme.palette.primary.main}
                className="fs-14 ff-Roboto fw-medium"
              >
                ADD TRADER
              </Typography>
            </IconButton> */}
            {(blockedStatus === '1') ? <Button onClick={() => {
              handleAddtrader();
            }} className="fs-14 ff-Roboto fw-medium" variant="text"> ADD TRADER</Button> : null}
          </Stack>
        </PageHeader>
        <Stack flex={1}>
          <div className="pb-[16px] relative  bg-[#f7f7f7] inputFormStyle overflow-auto">
            <Stack className="">
              <Datatable
                themeType={2}
                columns={columns}
                data={tradersList}
                isLoading={isLoading}
              />
            </Stack>
            {payload?.totalLength > 0 && <Box
              className="flex  justify-end items-center h-[56px] w-[100%] p-[5px] bg-[#FFFF]  mb-[10px] rounded-b-lg"
              sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}
            >
              <TablePagination
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>}
          </div>
        </Stack>
      </Stack>
    </Stack>
  );
}
